var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-form-wrapper"},[_c('form',{attrs:{"name":_vm.name,"action":_vm.action,"method":_vm.method}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }